import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "items-in-line image-modal-actions" }

import { useUserStore } from '@/store/modules/user';
import PhoneButton from '../../../PhoneButton/PhoneButton.vue';
import { CompareIcon } from '@/components/Cards/CardsComponents';
import { ResultCardType } from '@/types';
import { useChatStore } from '@/store/modules/chat';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionsForImageModal',
  props: {
    offerCard: {},
    phone: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_button, {
      "style-type": "coloredBorder",
      text: "Чат",
      onClick: _cache[0] || (_cache[0] = ($event: any) => {
        _unref(useChatStore)().openMiniMessenger(_ctx.offerCard);
        _ctx.$emit('close');
      })
    }),
    _createVNode(PhoneButton, {
      phone: _ctx.phone,
      height: "28"
    }, null, 8, ["phone"]),
    _createVNode(_component_base_button, {
      class: "scale",
      icon: "",
      "style-type": "border",
      withoutActive: "",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeIsFavorite', _ctx.offerCard.landId)))
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_base_icon, {
          color: _unref(useUserStore)().getIsFavorite(_ctx.offerCard.landId) ? '#EA1F1F' : '#969696',
          "font-size": "20",
          height: "22",
          name: "favorite",
          width: "22"
        }, null, 8, ["color"])
      ]),
      _: 1
    }),
    _createVNode(_unref(CompareIcon), {
      card: _ctx.offerCard,
      "with-border": ""
    }, null, 8, ["card"])
  ]))
}
}

})